import CloudServices from '@/views/Cloud/CloudServices';
const GCP = () => import('@/components/Cloud/services/gcp/');
const GKE = () => import('@/components/Cloud/services/gcp/gke');
import { components } from '@/components/Cloud/services/k8';
import AWSDashboard from '@/views/Cloud/AwsDashboard';
import AzureDashboard from '@/views/Cloud/AzureDashboard.vue';
import AwsOverviewView from '@/views/Cloud/aws/AwsOverviewView.vue';
import AwsSubscriptionView from '@/views/Cloud/aws/AwsSubscriptionView.vue';
import AwsServiceDetailView from '@/views/Cloud/aws/AwsServiceDetailView.vue';
import individualGraphPage from '@/components/Cloud/Dashboard/pages/lambda/individual-graph-page.vue';

export const cloud = [
  {
    path: 'cloud',
    name: 'cloud',
    component: CloudServices,
    children: [
      {
        path: 'gcp',
        name: 'gcp',
        component: GCP,
        redirect: {
          name: 'gke',
        },
        children: [
          {
            path: 'gke',
            name: 'gke',
            component: GKE,
            redirect: {
              name: 'nodes',
            },
            children: [
              {
                path: 'nodes',
                name: 'nodes',
                component: components.GenericCloudK8,
              },
              {
                path: 'pods',
                name: 'pods',
                component: components.GenericCloudK8,
              },
              {
                path: 'containers',
                name: 'containers',
                component: components.GenericCloudK8,
              },
            ],
          },
        ],
      },
      {
        path: 'aws',
        name: 'awsb',
        component: AWSDashboard,
        redirect: {
          name: 'awsoverview',
        },
        children: [
          {
            path: ':service/overview',
            name: 'awsoverview',
            component: AwsOverviewView,
          },
        ],
      },
      {
        path: 'azure',
        name: 'azure',
        component: AzureDashboard,
      },
    ],
  },
  {
    path: 'cloud/aws/:service/:subscriptionId/:serviceId',
    name: 'subscriptionId',
    component: AwsSubscriptionView,
  },
  {
    path: 'cloud/aws/:service/:subscriptionId/:serviceId/:databaseId',
    name: 'databaseId',
    component: AwsServiceDetailView,
  },
  {
    path: 'cloud/aws/:service/:subscriptionId/:serviceId/:graphName/display-graph',
    name: 'individualGraph',
    component: individualGraphPage,
  },
];
